<template>
    <div v-if="!rows.length" class="breakdown-empty">
        {{ empty }}
    </div>
    <v-simple-table v-else dense class="breakdown-table">
        <template v-slot:default>
            <thead>
                <tr>
                    <th />
                    <th class="text-right">
                        Matches
                    </th>
                    <th class="text-right">
                        Revenue
                    </th>
                    <th class="text-right">
                        Cost
                    </th>
                    <th class="text-right">
                        Result
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" :key="`${row.id}-${row.name}`">
                    <td class="breakdown-table__name">
                        {{ row.name }}
                    </td>
                    <td class="text-right">
                        {{ row.matches }}
                    </td>
                    <td class="text-right">
                        € {{ money(row.revenue) }}
                    </td>
                    <td class="text-right">
                        € {{ money(row.cost) }}
                    </td>
                    <td :class="['text-right', row.revenue - row.cost >= 0 ? 'breakdown-positive' : 'breakdown-negative']">
                        € {{ money(row.revenue - row.cost) }}
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
    // dashboard rows (per league / arena): matches, estimated revenue, cost and result
    export default {
        name: 'BreakdownTable',
        props: {
            rows: {
                type: Array,
                default: () => []
            },
            money: {
                type: Function,
                required: true
            },
            empty: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped>
.breakdown-empty {
    color: rgba(0, 0, 0, 0.45);
    font-size: 13px;
    padding: 8px 0;
}

.breakdown-table th {
    font-size: 11px !important;
    text-transform: uppercase;
}

.breakdown-table td {
    white-space: nowrap;
}

.breakdown-table .breakdown-table__name {
    white-space: normal;
    min-width: 130px;
    font-weight: 600;
}

.breakdown-positive {
    color: #2e7d32;
}

.breakdown-negative {
    color: #c62828;
}
</style>
